import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'simplePagination';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";

export class enrichGiftCardCatalogue {
    init():any{
        
        $('.enrich-giftcard-catalogue').addClass("hidden");
        $('#pagination').removeClass("hidden");
        
        let initialCountry = $('#enrich-giftcard-country-menu').find('li.active').text().trim();
        $(`.enrich-giftcard-catalogue[data-category=${initialCountry}]`).removeClass("hidden");
        this.pagination();
        $('#enrich-giftcard-country-menu ul li').click(function () {
            let tabName = $(this).html();
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Redemption Page - Gifts Cards',
                'clickName': 'click:tab-click:'+tabName.toLowerCase(),
                'componentType': 'tab',
                'componentName': 'tab',
                'componentID': 'click:tab-click:'+tabName.toLowerCase(),
                'attributes': []
            });
        });
    }
    validateForm(): any {
        let _self = this;
        let countries = $('#enrich-giftcard-country-menu').children('ul').find('li')
        countries.on('click', function() {
            countries.removeClass('active');
            $(this).addClass('active');
            var country_selected = $(this).text().trim();
            $('.enrich-giftcard-catalogue').addClass("hidden")
            $('#pagination').removeClass("hidden");

            if (country_selected == "Malaysia") {
                $('.enrich-giftcard-catalogue[data-category="Malaysia"]').removeClass("hidden");
                _self.pagination();
            }
            else if (country_selected == "Singapore") {
                $('.enrich-giftcard-catalogue[data-category="Singapore"]').removeClass("hidden");
                _self.pagination();
            }
            else if (country_selected == "Australia") {
                $('.enrich-giftcard-catalogue[data-category="Australia"]').removeClass("hidden");
                _self.pagination();
            }
            else if (country_selected == "India") {
                $('.enrich-giftcard-catalogue[data-category="India"]').removeClass("hidden");
                _self.pagination();
            }
            
        });
    }

    pagination(): any {
        let $listItems: any = $('#member-enrich-gift-card-catalogue .enrich-giftcard-catalogue:visible .padding-space');
        $listItems.show();
        let $numItems: any = $listItems.length;
        //let $listItemPerPage: any = $('#list-container').attr('data-listitems');
        let $itemPerPage: any = 6;
        if (window.innerWidth >= 1700) {
            $itemPerPage = 8;
        }
        let $pagination = $('#pagination');

        $listItems.slice($itemPerPage).hide();

        $pagination.pagination({
            items: $numItems,
            itemsOnPage: $itemPerPage,
            cssStyle: "light-theme",
            onPageClick: function (pageNumber: any) {
                let $showFrom: any = $itemPerPage * (pageNumber - 1);
                let $showTo: any = $showFrom + $itemPerPage;

                $listItems.hide()
                    .slice($showFrom, $showTo).show();
            }
        });
    }
}
let scope: Element = document.querySelector('#member-enrich-gift-card-catalogue');

if (scope) {
    try {
        let engccatalogue = new enrichGiftCardCatalogue();
        var adobeDataLayer = new adobeDataLayerWrapper();
		adobeDataLayer.push('pageLoaded', {
            'pageName': '',
            'pageType': 'Enrich Redemption Page - Gift Cards',
            'attributes': []
        });
        engccatalogue.init();
        engccatalogue.validateForm();
        engccatalogue.pagination();
    } catch (e) { console.error(e); }
}
